<template>
    <div style="width: 100%;height: calc(100% - 1rem);margin-top: 1rem">
      <el-row style="height: 100%">
        <el-col :span="6" style="height: 100%">
          <div class="showData">
            <el-descriptions style="height: 100%;background-color: #FFFFFF;padding-top: 2rem" :column="2"  direction="vertical" :colon="false">
              <el-descriptions-item>
                <template slot="label">
                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    测点编码</span>
                </template>
                <span class="contentStyle">{{tableData.mpcd ? tableData.mpcd : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item >
                <template slot="label">
                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpnm.svg" class="imgStyle"/>-->
                    测点名称</span>
                </template>
                <span class="contentStyle">{{tableData.mpnm ? tableData.mpnm : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span class="textStyle" >
<!--                    <img src="../../assets/icons/monitor/hycnnm.svg" class="imgStyle"/>-->
                    水工建筑物</span>
                </template>
                <span class="contentStyle">{{tableData.hycnnm ? tableData.hycnnm : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">

                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle" />-->
                    桩号</span>
                </template>
                <span class="contentStyle">{{tableData.ch ? tableData.ch : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    坝轴距</span>
                </template>
                <span class="contentStyle">{{tableData.ofax ? tableData.ofax : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    监测类型</span>
                </template>
                <span class="contentStyle"> {{tableData.mstpnm ? tableData.mstpnm : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span class="textStyle">
<!--                  <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    管口高程</span>
                </template>
                <span class="contentStyle">{{tableData.tbtpel ? tableData.tbtpel : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    管底高程</span>
                </template>
                <span class="contentStyle">{{tableData.tbbtel ? tableData.tbbtel : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    经度</span>
                </template>
                <span class="contentStyle"> {{tableData.lgtd ? tableData.lgtd : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    纬度</span>
                </template>
                <span class="contentStyle">{{tableData.lttd ? tableData.lttd : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
<!--              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  段底高程
                </template>
                江苏省苏州市吴中区吴中大道 1188 号
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  段顶高程
                </template>
                江苏省苏州市吴中区吴中大道 1188 号
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  监测类型
                </template>
                江苏省苏州市吴中区吴中大道 1188 号
              </el-descriptions-item>
             <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  安装高程
                </template>
                江苏省苏州市吴中区吴中大道 1188 号
              </el-descriptions-item>-->
<!--              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-office-building"></i>
                  仪器编号
                </template>
                江苏省苏州市吴中区吴中大道 1188 号
              </el-descriptions-item>-->
              <el-descriptions-item>
                <template slot="label">

                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    资料更新时间</span>
                </template>
                <span class="contentStyle">{{tableData.dtuptm ? tableData.dtuptm : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">

                  <span class="textStyle">
<!--                    <img src="../../assets/icons/monitor/mpcd.svg" class="imgStyle"/>-->
                    备注</span>
                </template>
                <span class="contentStyle">{{tableData.bz ? tableData.bz : ''}}</span>
                <div style="height: 3rem"></div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-col>
        <el-col :span="18" style="padding-left:2rem;height: 100%">
<!--            <div v-if="tableData.imgList">
                <el-carousel-item v-for="item in tableData.imgList" :key="item">
                    <img :src="fileHost + item.path" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);width: 100%;"/>
                </el-carousel-item>
            </div>-->
            <div  v-if="tableData.imgList" style="border: 1px solid #FFFFFF;height: 100%">

                <el-carousel  trigger="click" style="height:calc( 100vh - 22rem)">
                    <el-carousel-item v-for="(item,index) in tableData.imgList" :key="index" style="height:calc( 100vh - 22rem)">
                        <img style="width: 100%;height:calc( 100vh - 22rem)" :src="fileHost + item.path">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div v-else>
                <img fit="fill" v-if="tableData.mstp === '0601'" style="height: 100%;width: 100%" src="../../assets/icons/monitor/sppr_0601.jpg" />
                <img fit="fill" v-if="tableData.mstp === '0602'" style="height: 100%;width: 100%" src="../../assets/icons/monitor/sppr_0602.jpg" />
                <img fit="fill" v-if="tableData.mstp === '0603'" style="height: 100%;width: 100%" src="../../assets/icons/monitor/sppr_0603.jpg" />
                <img fit="fill" v-if="tableData.mstp === '0604,0605,0606'" style="height: 100%;width: 100%" src="../../assets/icons/monitor/sppr_gnss.jpg" />
            </div>
<!--         <el-image fit="fill" style="height: 100%;width: 100%" :src="tableData.img" />-->


        </el-col>
      </el-row>
    </div>
</template>
<script setup>
import {fileHost} from "@/utils/config";

  export default {
    data() {
      return {
          fileHost:fileHost,
        mpnm: '',
        mpcd: '',
        tableData: {},
        currentRow: null,
        dateTime: [],
        tableMaxHeight: null,
      }
    },

    methods: {
      reset(){
      },
      onWindowResize(){
      },
      calHeight(){
      },
      initCondition(mpnm,mpcd){
        this.mpcd = mpcd;
        this.mpnm = mpnm;
        this.queryData();
      },
      queryData(mpcd,onChange){
        // this.$parent.onChange(true);
        const params = {mpcd : mpcd};
        this.request.get('/rm-bmp/queryMp',{params}).then((res)=> {
            if(res.ok){
              if(res.data){
                this.tableData = res.data;
                console.log(" res.data", res.data)
                onChange(false);
              }
            }else{
              this.$message.error(res.error.message);
            }
        });
      },
    }
}
</script>
<style scoped>
  .labelStyle{
    display: flex;
    align-items: center;
  }
  .showData{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .activeButton{
    background-color: #409EFF;
    border-color: #409EFF;
  }
  .content_description_itemStyle{
    padding-bottom: 3rem;
  }
  .imgStyle{
    margin-right: 1rem;
  }
  .contentStyle{
    margin-left: 1rem;
    font-family: "PingFang SC";
    font-size: 1.9rem;
    line-height: 2.6rem;
    color: #323232;
    min-height: 4rem;

  }
  .textStyle{
    margin-left: 1rem;
    font-family: "PingFang SC";
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: #777777;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .pageStyle{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .tableDiv{
    width: 100%;
    height: 85%;
  }
</style>
